import React, { useEffect, useState } from 'react';
import { Step } from '../../../../types/wizard';
import { set3DEmblemOption, setEmblemLeatherOption, setEmblemPrintStitchOption, validateWizardSteps } from '../../../../stores/wizard';
import { Steps } from '../../../../constants';
import { useUIRules } from '../../../../hooks/useProductRules';

interface IndicationDisclaimerProps {
  step?: Step;
  title: string;
}

const IndicationDisclaimer: React.FC<IndicationDisclaimerProps> = ({ step, title }) => {
  const uiRules = useUIRules();
  const indicationRules = uiRules?.letStahlsChooseIndications;
  const [notAllowedToAdd, setNotAllowedToAdd] = useState(false);

  useEffect(() => {
    if (indicationRules?.defaultValue !== undefined) {
      setNotAllowedToAdd(indicationRules.defaultValue);
    }
  }, [indicationRules?.defaultValue]);

  useEffect(() => {
    const selectedOption = notAllowedToAdd ? "AllowWEIToChoose" : "IndicateParts";

    if (step?.id === Steps.Emblem3d) {
      set3DEmblemOption(step?.id as string, selectedOption);
    } else if (step?.id === Steps.EmblemLeather) {
      setEmblemLeatherOption(step?.id as string, selectedOption);
    } else {
      setEmblemPrintStitchOption(step?.id as string, selectedOption);
    }

    validateWizardSteps(step?.id);
  }, [notAllowedToAdd, step?.id]);

  if (indicationRules?.hidden) {
    return null;
  }

  const showToggle = !step?.hideWEtoChooseMyColors;
  const message = step?.disclaimer?.message;

  const handleClick = () => {
    setNotAllowedToAdd(!notAllowedToAdd);
  };

  return (
    <div className="text-gray-700 my-4">
      {message && (
        <div
          className="flex flex-row justify-start items-center pb-4 text-sm"
          dangerouslySetInnerHTML={{ __html: message }}
        />
      )}
      {showToggle && (
        <div className="flex flex-row justify-start items-center gap-4">
          <label className="font-bold">{title}</label>
          <div
            className={`relative flex items-center w-10 h-5 p-0.5 cursor-pointer rounded-full 
            ${notAllowedToAdd ? 'bg-blue-500' : 'bg-gray-300'}`}
            onClick={handleClick}
          >
            <div
              className={`w-4 h-4 rounded-full bg-white shadow-md transform transition-transform duration-300
              ${notAllowedToAdd ? 'translate-x-5' : 'translate-x-0'}`}
            />
          </div>
        </div>
      )}
      {notAllowedToAdd && (
        <div className="flex flex-col text-sm">
          <span className="mt-4 mb-4">
            The Stahls Design Team will select the indications based on your uploaded design and will match the design as closely as possible.
            Stahls is not responsible for design changes as a result of our selection on approved designs.
          </span>
          <span className="font-bold mb-4">
            Please be aware that this option may add up to two days to your design's turn-around time.
          </span>
        </div>
      )}
    </div>
  );
};

export default IndicationDisclaimer;